<template>
  <div class="college-web-container">
    <img src="@/assets/banner.jpg" class="header-img"/>
    <div class="content">
      <!-- 学院介绍 -->
      <div class="module"> 
        <img src="@/assets/college-intro.png" class="module-img"/>
        <div class="college-intro-content">
          <div class="college-intro-title">系统工程学院</div>
          <div class="college-intro-desc">
            <p class="college-intro-desc-item" v-for="(item, index) in collegeIntroList" :key="index">
              <img src="@/assets/college-intro-icon.png" class="intro-desc-item-icon"/>
              <span class="intro-desc-item-text" v-html="item.label || ''"></span>
            </p>
          </div>
        </div>
        <!-- 学科介绍/师资队伍 -->
        <div class="college-intro-desc2">
          <div class="subject-intro-content">
            <img src="@/assets/college-intro-bg3.png" class="subject-intro-bg"/>
            <div class="subject-intro-desc">
              <!-- <p class="subject-intro-desc-item" v-for="(item, index) in subjectIntroList" :key="index">
                <img src="@/assets/college-intro-icon2.png" class="subject-intro-desc-item-icon"/>
                <span class="subject-intro-desc-item-text">{{item.label || ''}}</span>
              </p> -->
              <img src="@/assets/college-intro-img3.png" class="subject-intro-bg-img"/>
            </div>
          </div>
          <div class="subject-intro-content2">
            <img src="@/assets/college-intro-bg1.png" class="subject-intro-bg"/>
            <div class="subject-intro-desc2">
              <p class="subject-intro-desc-item" v-for="(item, index) in tearchTeamList" :key="index">
                <img src="@/assets/college-intro-icon2.png" class="subject-intro-desc-item-icon"/>
                <span class="subject-intro-desc-item-text">{{item.label || ''}}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- 团队介绍 -->
      <div class="module module-team-intro-top positon-relative">
        <img src="@/assets/team-intro.png" class="module-img"/>
        <div class="team-intro-list">
          <div
            :class="[
              currentTeamIntroIndex == index ? 'team-intro-item-active' : '',
              'team-intro-item',
              item.fontSizeClass
            ]" 
            v-for="(item, index) in teamIntroList" 
            :key="index"
            @click="onTeamIntroItemClick(item, index)">
            {{item.label}}
          </div>
        </div>
        <p class="team-intro-desc">{{currentTeamIntroItem.value || ''}}</p>
        <img src="@/assets/team-intro-bg.png" class="team-intro-bg"/>
      </div>

      <!-- 办学条件  -->
      <div class="module module-school-condition-top">
        <img src="@/assets/school-condition.png" class="module-img"/>
        <div class="school-condition-wrapper">
          <img src="@/assets/school-condition-bg.png" class="school-condition-bg"/>
          <div class="school-condition-desc">
            <p class="school-condition-desc-item" v-for="(item, index) in schoolConditionList" :key="index">
              <img src="@/assets/college-intro-icon2.png" class="school-condition-desc-item-icon"/>
              <span class="school-condition-desc-item-text">{{item.label || ''}}</span>
            </p>
          </div>
        </div>
      </div>

      <!-- 科研成绩 -->
      <div class="module module-science-grade-top">
        <img src="@/assets/science-grade.png" class="module-img"/>
        <div class="science-grade-wrapper">
          <div class="science-grade-title">科研成绩</div>
          <div class="science-grade-desc">
            <p class="science-grade-desc-text" v-for="(item, index) in scienceGradeList" :key="index" v-html="item.label"></p>
          </div>
        </div>
      </div>

      <!-- 引进需求 -->
      <div class="module module-introduce-need-top">
        <img src="@/assets/introduce-need.png" class="module-img"/>
        <div class="introduce-need-list" v-for="(item, index) in introduceNeedList" :key="index">
          <span class="introduce-need-list-item paading-15 flex-32">{{item.label}}</span>
          <span class="introduce-need-list-item paading-30 flex-68">{{item.value}}</span>
        </div>
      </div>

      <!-- 引才类型 -->
      <div class="module module-introduce-need-top positon-relative">
        <img src="@/assets/introduce-type.png" class="module-img"/>
        <!-- <div class="introduce-type-wrapper">
          <div class="introduce-type-tab-wrapper">
            <div 
              :class="[
                currentIntroduceTypeIndex == index ? 'introduce-type-tab-item-active' : '',
                'introduce-type-tab-item'
              ]"
              v-for="(item, index) in introduceTypeList" 
              :key="index"
              @click="onIntroduceTypeItemClick(item, index)">
              <img :src="currentIntroduceTypeIndex == index ? require(`@/assets/introduceType/${item.icon}-white.png`) : require(`@/assets/introduceType/${item.icon}-red.png`)" class="introduce-type-tab-item-icon"/>
            </div>
            <div class="dotted-line"></div>
          </div>
          <div class="introduce-type-content">
            <div class="introduce-type-title">{{currentIntroduceTypeItem.label}}</div>
            <div class="introduce-type-desc">{{currentIntroduceTypeItem.value}}</div>
          </div>
        </div> -->
        <div class="introduce-type-wrapper2">
          <div class="introduce-type-tab-wrapper2">
            <div 
              :class="[
                currentIntroduceTypeIndex == index ? 'introduce-type-tab-item-active2' : '',
                'introduce-type-tab-item2'
              ]"
              v-for="(item, index) in introduceTypeList" 
              :key="index"
              @click="onIntroduceTypeItemClick(item, index)">
              <img 
                :src="currentIntroduceTypeIndex == index ? require(`@/assets/introduceType2/${item.icon}-red.png`) : require(`@/assets/introduceType2/${item.icon}-white.png`)" 
                class="introduce-type-tab-item-icon2"
                :style="{ width: `${item.iconWidth}px`, height: `${item.iconHeight}px`}"/>
              <span>{{item.label}}</span>
            </div>
          </div>
          <div class="introduce-type-content2">
            <div class="introduce-type-desc2">{{currentIntroduceTypeItem.value}}</div>
          </div>
        </div>
        <img src="@/assets/introduce-type-bg.png" class="introduce-type-bg"/>
      </div>

      <!-- 引进方式 -->
      <div class="module module-introduce-mode-top">
        <img src="@/assets/introduce-mode.png" class="module-img"/>
        <div class="introduce-mode-list">
          <div class="introduce-mode-item" v-for="(item, index) in introduceModeList" :key="index">
            <div class="introduce-mode-title">{{item.label}}</div>
            <div class="introduce-mode-desc">{{item.value}}</div>
            <img :src="require(`@/assets/introduceMode/${item.icon}.png`)" class="introduce-mode-img"/>
          </div>
        </div>
      </div>

      <!-- 待遇标准 -->
      <div class="module module-treatment-standard-top positon-relative">
        <img src="@/assets/treatment-standard.png" class="module-img"/>
        <div class="treatment-standard-tab">
          <div
            :class="[currentTreatmentStandardIndex == index ? 'treatment-standard-tab-item-active' : '', 'treatment-standard-tab-item']"
            v-for="(item, index) in treatmentStandardList"
            :key="index"
              @click="onTreatmentStandardItemClick(item, index)">
            <img :src="require(`@/assets/treatmentStandard/${item.icon}.png`)" class="treatment-standard-tab-item-icon"/>
            <span class="treatment-standard-tab-item-title">{{item.label}}</span>
          </div>
        </div>
        <div class="treatment-standard-content">
          <p class="treatment-standard-desc">{{currentTreatmentStandardItem.value || ''}}</p>
        </div>
        <img src="@/assets/treatment-standard-bg.png" class="treatment-standard-bg"/>
      </div>
    </div>

    <div class="footer">
      <img src="@/assets/footer-bg2.png" class="footer-bg"/>
      <div class="footer-qrcode">
        <img src="@/assets/qr-code.png" class="qr-code"/>
        <span class="qr-code-text">欢迎扫描上方二维码投递简历</span>
      </div>
      <div class="footer-content">
        <div class="footer-content-item" v-for="(item, index) in footerContentList" :key="index">
          <img :src="require(`@/assets/${item.icon}.png`)" class="footer-content-item-icon"/>
          <span class="footer-content-item-label">{{item.label}}:</span>
          <span class="footer-content-item-value" @click="onFooterActionClick(item)">{{item.value}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { collegeIntroList, subjectIntroList, tearchTeamList, teamIntroList, schoolConditionList, scienceGradeList, introduceNeedList, introduceTypeList, introduceModeList, treatmentStandardList, footerContentList } from '@/common/utlis/mockData'
export default {
  name: 'HomeView',
  components: {
  },
  data() {
    return {
      collegeIntroList,
      subjectIntroList,
      tearchTeamList,
      teamIntroList,
      currentTeamIntroIndex: 0,
      currentTeamIntroItem: teamIntroList[0],
      schoolConditionList,
      scienceGradeList,
      introduceNeedList,
      introduceTypeList,
      currentIntroduceTypeIndex: 0,
      currentIntroduceTypeItem: introduceTypeList[0],
      introduceModeList,
      treatmentStandardList,
      currentTreatmentStandardIndex: 0,
      currentTreatmentStandardItem: treatmentStandardList[0],
      footerContentList
    }
  },
  created() {
    // this.calcFontSize();
  },
  methods: {
    calcFontSize() {
      // 获取屏幕可视区域宽度
      let deviceWidth = document.documentElement.clientWidth;
      // 区分pc端和移动端，根据设计图宽度计算根字体大小
      if (deviceWidth > 768) {
        // 设计图宽度1920px / 实际字体大小100px = 19.20
        document.documentElement.style.fontSize = deviceWidth / 19.20 + 'px';
      } else {
        document.documentElement.style.fontSize = deviceWidth / 7.50 + 'px';
      }
    },
    onTeamIntroItemClick(item, index) {
      // let { currentTeamIntroIndex, currentTeamIntroItem } = this;
      this.currentTeamIntroItem = item;
      this.currentTeamIntroIndex = index;
    },
    onIntroduceTypeItemClick(item, index) {
      // let { currentTeamIntroIndex, currentTeamIntroItem } = this;
      this.currentIntroduceTypeItem = item;
      this.currentIntroduceTypeIndex = index;
    },
    onTreatmentStandardItemClick(item, index) {
      // let { currentTeamIntroIndex, currentTeamIntroItem } = this;
      this.currentTreatmentStandardItem = item;
      this.currentTreatmentStandardIndex = index;
    },
    onFooterActionClick(item) {
      if (item.aciton && item.action == 'call') {
        window.location.href = "tel://" + item.value;
      }
    }
  },
}
</script>

<style lang="less" scoped>
@vwUnit: 19.20;

.pxToVw(@px) {
  result: (@px / @vwUnit) * 1vw;
}
.college-web-container{
  width: 100%;
  height: 100%;
  // min-height: 100%;
  // overflow-y: auto;
  overflow-y: hidden;
}
.college-web-container:hover{
  overflow-y: overlay;
}
.college-web-container::-webkit-scrollbar{
  width: 0;
}
.college-web-container:hover::-webkit-scrollbar{
  width: 6px;
}
.college-web-container::-webkit-scrollbar-thumb{
  background-color: #ccc;
}
.college-web-container::-webkit-scrollbar-track{
  background-color: transparent;
}
.header-img{
  width: 100%;
  height: .pxToVw(691)[result];
}
.content{
  width: .pxToVw(1200)[result];
  margin: 0 auto;
}
.module{
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: .pxToVw(30)[result] 0;
}
.module-img{
  width: .pxToVw(327)[result];
  height: .pxToVw(93)[result];
  margin-bottom: .pxToVw(44)[result];
  z-index: 100;
}
.footer{
  width: 100%;
  height: .pxToVw(367)[result];
  background: url(~@/assets/footer-bg.png) no-repeat;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
}
.footer-bg{
  width: .pxToVw(335)[result];
  height: .pxToVw(225)[result];
}
.footer-qrcode{
  width: .pxToVw(210)[result];
  height: .pxToVw(230)[result];
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  margin-left: .pxToVw(36)[result];
}
.footer-qrcode::after{
  content: '';
  background-color: #510005;
  opacity: 0.35;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
}
.qr-code{
  width: .pxToVw(182)[result];
  height: .pxToVw(182)[result];
  z-index: 1;
}
.qr-code-text{
  font-size: .pxToVw(14)[result];
  color: #fefefe;
  margin-top: .pxToVw(4)[result];
  z-index: 1;
}
.footer-content{
  position: relative;
  width: .pxToVw(354)[result];
  height: .pxToVw(230)[result];
  // left: .pxToVw(260)[result];
  // top: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 .pxToVw(20)[result];
  margin-left: .pxToVw(36)[result];
}
.footer-content::after{
  content: '';
  background-color: #510005;
  opacity: 0.35;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
}
.footer-content-item{
  display: flex;
  align-items: center;
  z-index: 1;
  margin-top: .pxToVw(28)[result];
}
.footer-content-item:first-of-type{
  margin-top: 0;
}
.footer-content-item-icon{
  width: .pxToVw(16)[result];
  height: .pxToVw(16)[result];
  z-index: 1;
}
.footer-content-item-label{
  margin-left: .pxToVw(14)[result];
  font-size: .pxToVw(16)[result];
	letter-spacing: 1px;
  color: #fefefe;
  line-height: 100%;
}
.footer-content-item-value{
  margin-left: .pxToVw(8)[result];
  font-size: .pxToVw(16)[result];
	letter-spacing: 1px;
	color: #fefefe;
  line-height: 100%;
}
// ---------------------------学院介绍-----------------------------
.college-intro-content{
  width: 100%;
  background-color: #fff0f1;
  border-radius: .pxToVw(8)[result];
  display: flex;
  // align-items: center;
}
.college-intro-title{
  writing-mode: tb-rl;
  width: .pxToVw(77)[result];
	background-image: linear-gradient(90deg, 
		#f33e22 0%, 
		#a9171f 100%), 
	linear-gradient(
		#ffeaeb, 
		#ffeaeb);
	background-blend-mode: normal, 
		normal;
	border-radius: .pxToVw(8)[result] .pxToVw(30)[result] .pxToVw(30)[result] .pxToVw(8)[result];
  font-size: .pxToVw(26)[result];
	font-weight: normal;
	font-stretch: normal;
	// line-height: 26px;
	letter-spacing: .pxToVw(4)[result];
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: .pxToVw(30)[result] 0;
}
.college-intro-desc{
  flex: 1;
  margin: .pxToVw(32)[result] .pxToVw(16)[result] .pxToVw(32)[result] .pxToVw(26)[result];
}
.college-intro-desc-item{
  display: flex;
  margin-bottom: .pxToVw(16)[result];
}
.college-intro-desc-item:last-child{
  margin-bottom: 0;
}
.intro-desc-item-icon{
  width: .pxToVw(20)[result];
  height: .pxToVw(20)[result];
  margin-top: .pxToVw(5)[result];
}
.intro-desc-item-text{
  font-size: .pxToVw(16)[result];
	font-weight: normal;
	font-stretch: normal;
  // line-height: .pxToVw(26)[result];
  line-height: 1.5;
	letter-spacing: .pxToVw(1)[result];
  color: #333333;
  text-align: justify;
  text-align-last: left;
  margin-left: .pxToVw(18)[result];
}
// ---------------------------学院介绍-----------------------------
// ---------------------------学科介绍/师资队伍-----------------------------
.college-intro-desc2{
  margin-top: .pxToVw(26)[result];
  display: flex;
  width: 100%;
  justify-content: space-between;
}
.subject-intro-content{
  width: 59%;
  display: flex;
  flex-direction: column;
}
.subject-intro-content2{
  width: 40%;
  display: flex;
  flex-direction: column;
}
.subject-intro-bg{
  width: .pxToVw(102)[result];
  height: .pxToVw(24)[result];
}
.subject-intro-desc{
  background-color: #ffffff;
	box-shadow: 0px .pxToVw(4)[result] .pxToVw(15)[result] 0px 
    rgba(86, 86, 86, 0.15);
  margin-top: .pxToVw(18)[result];
  flex: 1;
  .subject-intro-bg-img{
    width: 100%;
    height: 100%;
    object-fit: cover;
    // image-rendering: pixelated;
  }
}
.subject-intro-desc2{
  background-color: #ffffff;
	box-shadow: 0px .pxToVw(4)[result] .pxToVw(15)[result] 0px 
    rgba(86, 86, 86, 0.15);
  padding: .pxToVw(25)[result] .pxToVw(20)[result];
  margin-top: .pxToVw(18)[result];
  flex: 1;
}
.subject-intro-desc-item{
  display: flex;
  margin-bottom: .pxToVw(20)[result];
}
.subject-intro-desc-item-icon{
  width: .pxToVw(13)[result];
  height: .pxToVw(13)[result];
  margin-top: .pxToVw(6)[result];
}
.subject-intro-desc-item-text{
  font-size: .pxToVw(16)[result];
	font-weight: normal;
	font-stretch: normal;
  // line-height: .pxToVw(26)[result];
  line-height: 1.5;
	letter-spacing: .pxToVw(1)[result];
  color: #333333;
  margin-left: .pxToVw(16)[result];
  text-align: justify;
  text-align-last: left;
}
// ---------------------------学科介绍/师资队伍-----------------------------
// ---------------------------团队介绍-----------------------------
.module-team-intro-top{
  margin-top: .pxToVw(104)[result];
}
.team-intro-list{
  width: 100%;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  row-gap: .pxToVw(22)[result];
  column-gap: .pxToVw(24)[result];
  z-index: 100;
}
.team-intro-item{
  border-radius: .pxToVw(23)[result];
  border: solid .pxToVw(1)[result] #a9171f;
  // height: .pxToVw(44)[result];
  padding: .pxToVw(8)[result] 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: .pxToVw(21)[result];
	letter-spacing: .pxToVw(2)[result];
  color: #a9171f;
  white-space: nowrap; //不换行
  overflow: hidden; //超出部分隐藏
  text-overflow: ellipsis; //文本溢出显示省略号
  cursor: pointer;
}
.team-intro-item-active{
  background-image: linear-gradient(90deg, 
		#f33e22 0%, 
		#a9171f 100%), 
	linear-gradient(
		#a9171f, 
		#a9171f);
	background-blend-mode: normal, 
    normal;
  border: none;
  color: #ffffff;
}
.font-size-16{
  font-size: .pxToVw(15)[result];
}
.font-size-18{
  font-size: .pxToVw(17)[result];
}
.team-intro-desc{
  margin: .pxToVw(35)[result] 0 .pxToVw(72)[result] 0;
  background-image: linear-gradient(90deg, 
		#ffffff 25%, 
		#fff0f1 100%), 
	linear-gradient(
		#ffffff, 
		#ffffff);
	background-blend-mode: normal, 
		normal;
	box-shadow: 0px .pxToVw(4)[result] .pxToVw(15)[result] 0px 
    rgba(86, 86, 86, 0.15);
  padding: .pxToVw(24)[result];
  font-size: .pxToVw(16)[result];
	line-height: 1.8;
	letter-spacing: 1px;
  color: #333333;
  z-index: 100;
  text-align: justify;
  text-align-last: left;
}
.positon-relative{
  position: relative;
}
.team-intro-bg{
  position: absolute;
  width: .pxToVw(1903)[result];
  height: .pxToVw(356)[result];
  bottom: 0;
}
// ---------------------------团队介绍-----------------------------
// ---------------------------办学条件-----------------------------
.module-school-condition-top{
  margin-top: .pxToVw(48)[result];
}
.school-condition-wrapper{
  display: flex;
  width: 100%;
}
.school-condition-bg{
  flex: 1;
  height: .pxToVw(327)[result];
}
.school-condition-desc{
  flex: 1;
  margin-left: .pxToVw(24)[result];
  background-color: #ffffff;
	box-shadow: 0px .pxToVw(4)[result] .pxToVw(15)[result] 0px 
    rgba(86, 86, 86, 0.15);
  padding: .pxToVw(25)[result] .pxToVw(20)[result];
}
.school-condition-desc-item{
  text-align: justify;
  text-align-last: left;
}
.school-condition-desc-item:last-child{
  margin-top: .pxToVw(16)[result];
}
.school-condition-desc-item-icon{
  width: .pxToVw(13)[result];
  height: .pxToVw(13)[result];
  margin-top: .pxToVw(6)[result];
}
.school-condition-desc-item-text{
  font-size: .pxToVw(16)[result];
	font-weight: normal;
	font-stretch: normal;
  line-height: .pxToVw(26)[result];
  // line-height: 1.5;
	letter-spacing: .pxToVw(1)[result];
  color: #333333;
  margin-left: .pxToVw(16)[result];
  text-align: justify;
  text-align-last: left;
}
.margin-top-26{
  margin-top: .pxToVw(16)[result];
}
// ---------------------------办学条件-----------------------------
// ---------------------------科研成绩-----------------------------
.module-science-grade-top{
  margin-top: .pxToVw(103)[result];
}
.science-grade-wrapper{
  width: 100%;
  height: .pxToVw(308)[result];
  background: url(~@/assets/science-grade-bg.png) no-repeat;
  background-size: contain;
  display: flex;
  align-items: center;
}
.science-grade-title{
  writing-mode: tb-rl;
  font-size: .pxToVw(32)[result];
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: .pxToVw(5)[result];
  color: #ffe093;
  width: 12%;
  /* text-align: left; */
  display: flex;
  align-items: center;
}
.science-grade-desc{
  flex: 1;
  margin-right: .pxToVw(30)[result];
}
.science-grade-desc-text{
  text-indent: 2em;
  font-size: .pxToVw(18)[result];
	font-weight: normal;
	font-stretch: normal;
	line-height: .pxToVw(38)[result];
	letter-spacing: .pxToVw(1)[result];
	color: #ffffff;
  text-align: justify;
  text-align-last: left;
}
// ---------------------------科研成绩 -----------------------------
// ---------------------------引进需求-----------------------------
.module-introduce-need-top{
  margin-top: .pxToVw(99)[result];
  z-index: 100;
}
.introduce-need-list{
  width: calc(100% - 34px);
  display: flex;
  border-left: solid .pxToVw(17)[result] #bd2727;
  // border-bottom: solid 1px #d2d2d2;
  border-right: solid .pxToVw(17)[result] #bd2727;
  height: .pxToVw(88)[result];
  font-size: .pxToVw(16)[result];
	letter-spacing: 1px;
	color: #333333;
}
.introduce-need-list:nth-of-type(odd) {
  background-color: #fee9e9;
}
.introduce-need-list:first-of-type{
  border-left: solid .pxToVw(17)[result] #a9171f;
  // border-bottom: none;
  border-right: solid .pxToVw(17)[result] #a9171f;
  background-color: #a9171f;
  height: .pxToVw(66)[result];
  font-size: .pxToVw(22)[result];
  font-weight: bold;
	letter-spacing: 1px;
  color: #ffe093;
}
.introduce-need-list:last-of-type{
  border-bottom: solid .pxToVw(17)[result] #bd2727;
}
.introduce-need-list-item{
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.introduce-need-list:not(:first-of-type) .introduce-need-list-item:first-child{
  border-right: solid 1px #d2d2d2;
}
.introduce-need-list:not(:first-of-type) .introduce-need-list-item{
  border-bottom: solid 1px #d2d2d2;
}
.paading-15{
  padding: 0 .pxToVw(15)[result];
}
.paading-30{
  padding: 0 .pxToVw(30)[result];
}
.flex-32 {
  width: 32%;
}
.flex-68 {
  width: 68%;
}
// ---------------------------引进需求-----------------------------
// ---------------------------引才类型 -----------------------------
.introduce-type-wrapper{
  background-color: #ffffff;
	box-shadow: 0px .pxToVw(4)[result] .pxToVw(15)[result] 0px 
    rgba(86, 86, 86, 0.15);
  z-index: 100;
  width: 100%;
}
.introduce-type-tab-wrapper{
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  margin: .pxToVw(24)[result] .pxToVw(24)[result] 0 .pxToVw(24)[result];
}
.introduce-type-tab-item{
  width: .pxToVw(42)[result];
	height: .pxToVw(42)[result];
	background-image: linear-gradient(0deg, 
		#fffafb 0%, 
		#ffe9ea 100%);
  border: solid .pxToVw(2)[result] #ffd2d4;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 100;
}
.introduce-type-tab-item-active{
	background-image: linear-gradient(0deg, 
		#de4c54 0%, 
    #fe6c74 100%);
  border: solid .pxToVw(2)[result] rgba(255, 111, 120, 0.22);
  position: relative;
}
.introduce-type-tab-item-active::before{
  position: absolute;
  content: '';
  width: 0;
  height: 0;
  // top: calc(100% + 2px);
  top: 100%;
  left: 50%;
  transform: translate(-50%, 0);
  border-top: solid .pxToVw(8)[result] #de4c54;
  border-right: solid .pxToVw(8)[result] transparent;
  border-left: solid .pxToVw(8)[result] transparent;
}
.introduce-type-tab-item-icon{
  width: .pxToVw(25)[result];
  height: .pxToVw(25)[result];
}
.dotted-line{
  position: absolute;
  top: 50%;
  width: 96%;
  left: 50%;
  border: dotted 1px #ff959b;
  transform: translate(-50%, -50%);
}
.introduce-type-content{
  margin: .pxToVw(28)[result] .pxToVw(24)[result] .pxToVw(24)[result] .pxToVw(24)[result];
  background-color: #fff9f9;
  border-top-left-radius: .pxToVw(32)[result];
}
.introduce-type-title{
  display: inline-block;
  width: .pxToVw(236)[result];
  height: .pxToVw(50)[result];
  line-height: .pxToVw(50)[result];
  // padding: 0 .pxToVw(40)[result];
  // display: flex;
  // align-items: center;
  // background-image: linear-gradient(0deg, 
	// 	#E6DBE3 0%, 
  //   #E6ABB6 100%);
  // background-image: linear-gradient(90deg, #f33e22 0%, #a9171f 100%), linear-gradient(#a9171f, #a9171f);
  // background-blend-mode: normal, normal;
  background: url(~@/assets/title_bg.png) no-repeat;
  background-size: contain;
  // border-top-left-radius: .pxToVw(32)[result];
  // border-bottom-right-radius: .pxToVw(32)[result];
  font-size: .pxToVw(22)[result];
	font-weight: bold;
	font-stretch: normal;
	letter-spacing: 1px;
  color: #a9171f;
  text-align: center;
}
.introduce-type-desc{
  padding: .pxToVw(26)[result];
  font-size: .pxToVw(16)[result];
	font-weight: normal;
	font-stretch: normal;
	line-height: .pxToVw(28)[result];
	letter-spacing: 1px;
  color: #333333;
  white-space: pre-wrap;
  text-align: justify;
  text-align-last: left;
}
.introduce-type-bg{
  position: absolute;
  width: .pxToVw(1903)[result];
  height: .pxToVw(525)[result];
  bottom: .pxToVw(-30)[result];
}
.introduce-type-wrapper2{
  z-index: 100;
  width: 100%;
  height: .pxToVw(528)[result];
  display: flex;
  .introduce-type-tab-wrapper2{
    width: 19.42%;
    height: 100%;
    background-image: url('../assets/introduce-type-tab-bg.png');
    background-size: cover;
    display: flex;
    flex-direction: column;
    justify-content: center;
    .introduce-type-tab-item2{
      width: 100%;
      height: .pxToVw(70)[result];
      border-bottom: 1px solid rgba(255, 255, 255, 0.5);
      display: flex;
      align-items: center;
      justify-content: center;
      gap: .pxToVw(14)[result];
      font-size: .pxToVw(22)[result];
      font-weight: normal;
      font-stretch: normal;
      // line-height: .pxToVw(25)[result];
      letter-spacing: 1px;
      color: #fff;
      cursor: pointer;
    }
    .introduce-type-tab-item-active2{
      background-color: #fee9e9;
      color: #a9171f;
    }
    .introduce-type-tab-item-icon2{
      width: .pxToVw(25)[result];
      height: .pxToVw(25)[result];
    }
  }
  .introduce-type-content2{
    width: 80.58%;
    height: calc(100% - 11px);
    background-image: url('../assets/introduce-type-content-bg.png');
    background-size: 100% 100%;
    box-shadow: 4px 5px 24px 0px 
		rgba(206, 206, 206, 0.42);
    .introduce-type-desc2{
      padding: .pxToVw(60)[result] .pxToVw(50)[result] 0 .pxToVw(50)[result];
      font-size: .pxToVw(16)[result];
      font-weight: normal;
      font-stretch: normal;
      line-height: .pxToVw(28)[result];
      letter-spacing: 1px;
      color: #333333;
      white-space: pre-wrap;
      text-align: justify;
      text-align-last: left;
    }
  }
}
// ---------------------------引才类型-----------------------------
// ---------------------------引进方式-----------------------------
.module-introduce-mode-top{
  margin-top: .pxToVw(90)[result];
}
.introduce-mode-list{
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.introduce-mode-item{
  width: .pxToVw(180)[result];
  height: .pxToVw(360)[result];
  background-color: #ffffff;
	box-shadow: 0px 4px 15px 0px 
    rgba(86, 86, 86, 0.15);
  position: relative;
}
.introduce-mode-title{
  text-align: center;
  margin-top: .pxToVw(30)[result];
  font-size: .pxToVw(22)[result];
  letter-spacing: 1px;
  font-weight: bold;
	color: #a9171f;
}
.introduce-mode-desc{
  text-align: center;
  margin-top: .pxToVw(24)[result];
  font-size: .pxToVw(16)[result];
	letter-spacing: 1px;
  color: #333;
  white-space: pre-wrap;
}
.introduce-mode-img{
  position: absolute;
  bottom: .pxToVw(12)[result];
  left: 50%;
  width: .pxToVw(66)[result];
  height: .pxToVw(68)[result];
  transform: translate(-50%, 0);
}
// ---------------------------引进方式 -----------------------------
// ---------------------------待遇标准 -----------------------------
.module-treatment-standard-top{
  margin-top: .pxToVw(101)[result];
  margin-bottom: .pxToVw(101)[result];
  z-index: 100;
}
.treatment-standard-tab{
  width: 100%;
  display: flex;
  z-index: 100;
}
.treatment-standard-tab-item{
  flex: 1;
  height: .pxToVw(180)[result];
  display: flex;
  align-items: center;
  // justify-content: center;
  flex-direction: column;
  background-color: #FFF4F4;
  color: #333333;
  font-size: .pxToVw(16)[result];
  cursor: pointer;
}
.treatment-standard-tab-item-active{
  background-color: #ffaca4;
  color: #ffffff;
  font-size: .pxToVw(18)[result];
}
.treatment-standard-tab-item-icon{
  width: .pxToVw(46)[result];
  height: .pxToVw(42)[result];
  margin-top: .pxToVw(40)[result];
}
.treatment-standard-tab-item-title{
	line-height: .pxToVw(22)[result];
	letter-spacing: 1px;
  white-space: pre-wrap;
  text-align: center;
  margin-top: .pxToVw(24)[result];
}
.treatment-standard-bg{
  position: absolute;
  width: .pxToVw(1903)[result];
  height: .pxToVw(199)[result];
  top: .pxToVw(138)[result];
}
.treatment-standard-content{
  width: 100%;
  background-color: #ffffff;
	box-shadow: 0px .pxToVw(4)[result] .pxToVw(15)[result] 0px 
    rgba(86, 86, 86, 0.15);
  z-index: 100;
}
.treatment-standard-desc{
  padding: .pxToVw(24)[result];
  font-size: .pxToVw(16)[result];
	line-height: .pxToVw(30)[result];
	letter-spacing: .pxToVw(2)[result];
	color: #333333;
  white-space: pre-wrap;
  text-align: justify;
  text-align-last: left;
}
// ---------------------------待遇标准 -----------------------------
// TODO: 手机模式下的样式： 重点修改，因为他们常用的是手机查看
@media screen and (max-width: 768px) {
  @vwUnit: 7.50;
  .pxToVw(@px) {
    result: (@px / @vwUnit) * 1vw;
  }
  .college-web-container{
    width: 100%;
    // min-height: 100%;
    overflow-y: auto;
  }
  .header-img{
    width: 100%;
    height: .pxToVw(270)[result];
  }
  .content{
    width: 95%;
    margin: 0 auto;
  }
  .module{
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: .pxToVw(30)[result] 0;
  }
  .module-img{
    width: .pxToVw(327)[result];
    height: .pxToVw(93)[result];
    margin-bottom: .pxToVw(44)[result];
    z-index: 100;
  }
  .footer{
    width: 100%;
    height: .pxToVw(367)[result];
    background: url(~@/assets/footer-bg.png) no-repeat;
    background-size: cover;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .footer-bg{
    width: .pxToVw(245)[result];
    height: .pxToVw(165)[result];
  }
  .footer-qrcode{
    width: .pxToVw(160)[result];
    height: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    margin-left: .pxToVw(16)[result];
    overflow: hidden;
    padding: .pxToVw(12)[result] 0;
  }
  .footer-qrcode::after{
    content: '';
    background-color: #510005;
    opacity: 0.35;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
  }
  .qr-code{
    width: .pxToVw(132)[result];
    height: .pxToVw(132)[result];
    z-index: 1;
  }
  .qr-code-text{
    font-size: .pxToVw(12)[result];
    color: #fefefe;
    margin-top: .pxToVw(4)[result];
    z-index: 1;
    text-align: center;
  }
  .footer-content{
    position: relative;
    width: .pxToVw(230)[result];
    height: auto;
    // left: .pxToVw(160)[result];
    // top: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: .pxToVw(12)[result];
    margin-left: .pxToVw(16)[result];
  }
  .footer-content::after{
    content: '';
    background-color: #510005;
    opacity: 0.35;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
  }
  .footer-content-item{
    display: flex;
    align-items: center;
    z-index: 1;
    margin-top: .pxToVw(28)[result];
    overflow: hidden;
  }
  .footer-content-item:first-of-type{
    margin-top: 0;
  }
  .footer-content-item-icon{
    width: .pxToVw(16)[result];
    height: .pxToVw(16)[result];
    z-index: 1;
  }
  .footer-content-item-label{
    margin-left: .pxToVw(14)[result];
    font-size: .pxToVw(14)[result];
    letter-spacing: 1px;
    color: #fefefe;
    line-height: 100%;
    display: none;
  }
  .footer-content-item-value{
    flex: 1;
    margin-left: .pxToVw(8)[result];
    font-size: .pxToVw(14)[result];
    letter-spacing: 1px;
    color: #fefefe;
    line-height: 100%;
    // text-align: center;
    word-break: break-all;
  }
  // ---------------------------学院介绍-----------------------------
  .college-intro-content{
    width: 100%;
    background-color: #fff0f1;
    border-radius: .pxToVw(8)[result];
    display: flex;
    // align-items: center;
  }
  .college-intro-title{
    writing-mode: tb-rl;
    width: .pxToVw(77)[result];
    background-image: linear-gradient(90deg, 
      #f33e22 0%, 
      #a9171f 100%), 
    linear-gradient(
      #ffeaeb, 
      #ffeaeb);
    background-blend-mode: normal, 
      normal;
    border-radius: .pxToVw(8)[result] .pxToVw(30)[result] .pxToVw(30)[result] .pxToVw(8)[result];
    font-size: .pxToVw(28)[result];
    font-weight: normal;
    font-stretch: normal;
    // line-height: 26px;
    letter-spacing: .pxToVw(4)[result];
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: .pxToVw(30)[result] 0;
  }
  .college-intro-desc{
    flex: 1;
    margin: .pxToVw(32)[result] .pxToVw(16)[result] .pxToVw(32)[result] .pxToVw(26)[result];
  }
  .college-intro-desc-item{
    display: flex;
    margin-bottom: .pxToVw(16)[result];
  }
  .college-intro-desc-item:last-child{
    margin-bottom: 0;
  }
  .intro-desc-item-icon{
    width: .pxToVw(20)[result];
    height: .pxToVw(20)[result];
    margin-top: .pxToVw(5)[result];
  }
  .intro-desc-item-text{
    font-size: .pxToVw(18)[result];
    font-weight: normal;
    font-stretch: normal;
    // line-height: .pxToVw(26)[result];
    line-height: 1.5;
    letter-spacing: .pxToVw(1)[result];
    color: #333333;
    margin-left: .pxToVw(18)[result];
  }
  // ---------------------------学院介绍-----------------------------
  // ---------------------------学科介绍/师资队伍-----------------------------
  .college-intro-desc2{
    margin-top: .pxToVw(26)[result];
    display: block;
    width: 100%;
    // justify-content: space-between;
    // flex-direction: column;
  }
  .subject-intro-content{
    width: 100%;
    display: flex;
    flex-direction: column;
  }
  .subject-intro-content2{
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-top: .pxToVw(26)[result];
  }
  .subject-intro-bg{
    width: .pxToVw(102)[result];
    height: .pxToVw(24)[result];
  }
  .subject-intro-desc{
    background-color: #ffffff;
    box-shadow: 0px .pxToVw(4)[result] .pxToVw(15)[result] 0px 
      rgba(86, 86, 86, 0.15);
    margin-top: .pxToVw(18)[result];
    // flex: 1;
    width: 100%;
    height: .pxToVw(424)[result];
    .subject-intro-bg-img{
      width: 100%;
      height: 100%;
      object-fit: cover;
      vertical-align: middle;
      // image-rendering: pixelated;
      // display: none;
    }
  }
  .subject-intro-desc2{
    background-color: #ffffff;
    box-shadow: 0px .pxToVw(4)[result] .pxToVw(15)[result] 0px 
      rgba(86, 86, 86, 0.15);
    padding: .pxToVw(25)[result] .pxToVw(20)[result];
    margin-top: .pxToVw(18)[result];
    flex: 1;
  }
  .subject-intro-desc-item{
    display: flex;
    margin-bottom: .pxToVw(20)[result];
  }
  .subject-intro-desc-item-icon{
    width: .pxToVw(13)[result];
    height: .pxToVw(13)[result];
    margin-top: .pxToVw(6)[result];
  }
  .subject-intro-desc-item-text{
    font-size: .pxToVw(18)[result];
    font-weight: normal;
    font-stretch: normal;
    // line-height: .pxToVw(26)[result];
    line-height: 1.5;
    letter-spacing: .pxToVw(1)[result];
    color: #333333;
    margin-left: .pxToVw(16)[result];
  }
  // ---------------------------学科介绍/师资队伍-----------------------------
  // ---------------------------团队介绍-----------------------------
  .module-team-intro-top{
    margin-top: .pxToVw(104)[result];
  }
  .team-intro-list{
    width: 100%;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    row-gap: .pxToVw(22)[result];
    column-gap: .pxToVw(24)[result];
    z-index: 100;
  }
  .team-intro-item{
    border-radius: .pxToVw(23)[result];
    border: solid .pxToVw(1)[result] #a9171f;
    // height: .pxToVw(44)[result];
    padding: .pxToVw(8)[result] 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: .pxToVw(22)[result];
    letter-spacing: .pxToVw(2)[result];
    color: #a9171f;
    white-space: nowrap; //不换行
    overflow: hidden; //超出部分隐藏
    text-overflow: ellipsis; //文本溢出显示省略号
    cursor: pointer;
  }
  .team-intro-item-active{
    background-image: linear-gradient(90deg, 
      #f33e22 0%, 
      #a9171f 100%), 
    linear-gradient(
      #a9171f, 
      #a9171f);
    background-blend-mode: normal, 
      normal;
    border: none;
    color: #ffffff;
  }
  .font-size-16{
    font-size: .pxToVw(18)[result];
  }
  .font-size-18{
    font-size: .pxToVw(18)[result];
  }
  .team-intro-desc{
    margin: .pxToVw(35)[result] 0 .pxToVw(72)[result] 0;
    background-image: linear-gradient(90deg, 
      #ffffff 25%, 
      #fff0f1 100%), 
    linear-gradient(
      #ffffff, 
      #ffffff);
    background-blend-mode: normal, 
      normal;
    box-shadow: 0px .pxToVw(4)[result] .pxToVw(15)[result] 0px 
      rgba(86, 86, 86, 0.15);
    padding: .pxToVw(24)[result];
    font-size: .pxToVw(18)[result];
    line-height: 1.8;
    letter-spacing: 1px;
    color: #333333;
    z-index: 100;
  }
  .positon-relative{
    position: relative;
  }
  .team-intro-bg{
    position: absolute;
    width: 100vw;
    height: .pxToVw(356)[result];
    bottom: 0;
  }
  // ---------------------------团队介绍-----------------------------
  // ---------------------------办学条件-----------------------------
  .module-school-condition-top{
    margin-top: .pxToVw(48)[result];
  }
  .school-condition-wrapper{
    // display: flex;
    width: 100%;
    display: block;
  }
  .school-condition-bg{
    // flex: 1;
    float: left;
    clear: both;
    width: .pxToVw(229)[result];
    height: .pxToVw(127)[result];
    object-fit: cover;
    padding: .pxToVw(25)[result] .pxToVw(20)[result];
  }
  .school-condition-desc{
    // flex: 1;
    margin-left: 0;
    background-color: #ffffff;
    box-shadow: 0px .pxToVw(4)[result] .pxToVw(15)[result] 0px 
      rgba(86, 86, 86, 0.15);
    padding: .pxToVw(25)[result] .pxToVw(20)[result];
  }
  .school-condition-desc-item-icon{
    width: .pxToVw(13)[result];
    height: .pxToVw(13)[result];
    margin-top: .pxToVw(6)[result];
  }
  .school-condition-desc-item-text{
    font-size: .pxToVw(18)[result];
    font-weight: normal;
    font-stretch: normal;
    line-height: .pxToVw(26)[result];
    // line-height: 1.5;
    letter-spacing: .pxToVw(1)[result];
    color: #333333;
    margin-left: .pxToVw(16)[result];
  }
  .margin-top-26{
    margin-top: .pxToVw(16)[result];
  }
  // ---------------------------办学条件-----------------------------
  // ---------------------------科研成绩-----------------------------
  .module-science-grade-top{
    margin-top: .pxToVw(103)[result];
  }
  .science-grade-wrapper{
    width: 100%;
    height: auto;
    background: url(~@/assets/science-grade-bg.png) no-repeat;
    background-size: cover;
    display: flex;
    align-items: center;
  }
  .science-grade-title{
    writing-mode: tb-rl;
    font-size: .pxToVw(32)[result];
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: .pxToVw(5)[result];
    color: #ffe093;
    width: 19%;
    /* text-align: left; */
    display: flex;
    align-items: center;
  }
  .science-grade-desc{
    flex: 1;
    margin-right: .pxToVw(30)[result];
    margin-top: .pxToVw(20)[result];
    margin-bottom: .pxToVw(20)[result];
  }
  .science-grade-desc-text{
    text-indent: 2em;
    font-size: .pxToVw(18)[result];
    font-weight: normal;
    font-stretch: normal;
    line-height: 1.4;
    letter-spacing: .pxToVw(1)[result];
    color: #ffffff;
  }
  // ---------------------------科研成绩 -----------------------------
  // ---------------------------引进需求-----------------------------
  .module-introduce-need-top{
    margin-top: .pxToVw(99)[result];
    z-index: 100;
  }
  .introduce-need-list{
    width: calc(100% - 34px);
    display: flex;
    border-left: solid .pxToVw(8)[result] #bd2727;
    // border-bottom: solid 1px #d2d2d2;
    border-right: solid .pxToVw(8)[result] #bd2727;
    height: .pxToVw(88)[result];
    font-size: .pxToVw(16)[result];
    letter-spacing: 1px;
    color: #333333;
  }
  .introduce-need-list:nth-of-type(odd) {
    background-color: #fee9e9;
  }
  .introduce-need-list:first-of-type{
    border-left: solid .pxToVw(8)[result] #a9171f;
    // border-bottom: none;
    border-right: solid .pxToVw(8)[result] #a9171f;
    background-color: #a9171f;
    height: .pxToVw(66)[result];
    font-size: .pxToVw(22)[result];
    font-weight: bold;
    letter-spacing: 1px;
    color: #ffe093;
  }
  .introduce-need-list:last-of-type{
    border-bottom: solid .pxToVw(8)[result] #bd2727;
  }
  .introduce-need-list-item{
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }
  .introduce-need-list:not(:first-of-type) .introduce-need-list-item:first-child{
    border-right: solid 1px #d2d2d2;
  }
  .introduce-need-list:not(:first-of-type) .introduce-need-list-item{
    border-bottom: solid 1px #d2d2d2;
  }
  .paading-15{
    padding: 0 .pxToVw(15)[result];
  }
  .paading-30{
    padding: .pxToVw(12)[result] .pxToVw(30)[result];
  }
  .flex-32 {
    width: 32%;
  }
  .flex-68 {
    width: 68%;
  }
  // ---------------------------引进需求-----------------------------
  // ---------------------------引才类型 -----------------------------
  .introduce-type-wrapper{
    background-color: #ffffff;
    box-shadow: 0px .pxToVw(4)[result] .pxToVw(15)[result] 0px 
      rgba(86, 86, 86, 0.15);
    z-index: 100;
    width: 100%;
  }
  .introduce-type-tab-wrapper{
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    margin: .pxToVw(24)[result] .pxToVw(24)[result] 0 .pxToVw(24)[result];
  }
  .introduce-type-tab-item{
    width: .pxToVw(42)[result];
    height: .pxToVw(42)[result];
    background-image: linear-gradient(0deg, 
      #fffafb 0%, 
      #ffe9ea 100%);
    border: solid .pxToVw(2)[result] #ffd2d4;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 100;
  }
  .introduce-type-tab-item-active{
    background-image: linear-gradient(0deg, 
      #de4c54 0%, 
      #fe6c74 100%);
    border: solid .pxToVw(2)[result] rgba(255, 111, 120, 0.22);
    position: relative;
  }
  .introduce-type-tab-item-active::before{
    position: absolute;
    content: '';
    width: 0;
    height: 0;
    // top: calc(100% + 2px);
    top: 100%;
    left: 50%;
    transform: translate(-50%, 0);
    border-top: solid .pxToVw(8)[result] #de4c54;
    border-right: solid .pxToVw(8)[result] transparent;
    border-left: solid .pxToVw(8)[result] transparent;
  }
  .introduce-type-tab-item-icon{
    width: .pxToVw(25)[result];
    height: .pxToVw(25)[result];
  }
  .dotted-line{
    position: absolute;
    top: 50%;
    width: 96%;
    left: 50%;
    border: dotted 1px #ff959b;
    transform: translate(-50%, -50%);
  }
  .introduce-type-content{
    margin: .pxToVw(28)[result] .pxToVw(24)[result] .pxToVw(24)[result] .pxToVw(24)[result];
    background-color: #fff9f9;
    border-top-left-radius: .pxToVw(32)[result];
  }
  .introduce-type-title{
    display: inline-block;
    width: .pxToVw(236)[result];
    height: .pxToVw(50)[result];
    line-height: .pxToVw(50)[result];
    // padding: 0 .pxToVw(40)[result];
    // display: flex;
    // align-items: center;
    // background-image: linear-gradient(0deg, 
    // 	#E6DBE3 0%, 
    //   #E6ABB6 100%);
    // background-image: linear-gradient(90deg, #f33e22 0%, #a9171f 100%), linear-gradient(#a9171f, #a9171f);
    // background-blend-mode: normal, normal;
    background: url(~@/assets/title_bg.png) no-repeat;
    background-size: contain;
    // border-top-left-radius: .pxToVw(32)[result];
    // border-bottom-right-radius: .pxToVw(32)[result];
    font-size: .pxToVw(22)[result];
    font-weight: bold;
    font-stretch: normal;
    letter-spacing: 1px;
    color: #a9171f;
    text-align: center;
  }
  .introduce-type-desc{
    padding: .pxToVw(26)[result];
    font-size: .pxToVw(18)[result];
    font-weight: normal;
    font-stretch: normal;
    line-height: .pxToVw(28)[result];
    letter-spacing: 1px;
    color: #333333;
    white-space: pre-wrap;
  }
  .introduce-type-bg{
    position: absolute;
    width: 100vw;
    height: .pxToVw(525)[result];
    bottom: .pxToVw(-30)[result];
  }
  .introduce-type-wrapper2{
    z-index: 100;
    width: 100%;
    height: .pxToVw(600)[result];
    display: flex;
    .introduce-type-tab-wrapper2{
      width: 26%;
      height: 100%;
      background-image: url('../assets/introduce-type-tab-bg.png');
      background-size: cover;
      display: flex;
      flex-direction: column;
      justify-content: center;
      .introduce-type-tab-item2{
        width: 100%;
        height: .pxToVw(70)[result];
        border-bottom: 1px solid rgba(255, 255, 255, 0.5);
        display: flex;
        align-items: center;
        justify-content: center;
        gap: .pxToVw(12)[result];
        font-size: .pxToVw(18)[result];
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 1px;
        color: #fff;
        cursor: pointer;
      }
      .introduce-type-tab-item-active2{
        background-color: #fee9e9;
        color: #a9171f;
      }
      .introduce-type-tab-item-icon2{
        width: .pxToVw(20)[result]!important;
        height: .pxToVw(20)[result]!important;
      }
    }
    .introduce-type-content2{
      width: 74%;
      height: calc(100% - 11px);
      background-image: url('../assets/introduce-type-content-bg.png');
      background-size: 100% 100%;
      box-shadow: 4px 5px 24px 0px 
      rgba(206, 206, 206, 0.42);
      .introduce-type-desc2{
        padding: .pxToVw(20)[result] .pxToVw(20)[result] 0 .pxToVw(20)[result];
        font-size: .pxToVw(18)[result];
        font-weight: normal;
        font-stretch: normal;
        line-height: .pxToVw(24)[result];
        letter-spacing: 1px;
        color: #333333;
        white-space: pre-wrap;
        text-align: justify;
        text-align-last: left;
      }
    }
  }
  // ---------------------------引才类型-----------------------------
  // ---------------------------引进方式-----------------------------
  .module-introduce-mode-top{
    margin-top: .pxToVw(90)[result];
  }
  .introduce-mode-list{
    width: 100%;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    row-gap: .pxToVw(24)[result];
    column-gap: .pxToVw(24)[result];
  }
  .introduce-mode-item{
    width: 100%;
    // height: .pxToVw(360)[result];
    height: auto;
    background-color: #ffffff;
    box-shadow: 0px 4px 15px 0px 
      rgba(86, 86, 86, 0.15);
    position: relative;
  }
  .introduce-mode-title{
    text-align: center;
    margin-top: .pxToVw(30)[result];
    font-size: .pxToVw(22)[result];
    letter-spacing: 1px;
    font-weight: bold;
    color: #a9171f;
  }
  .introduce-mode-desc{
    text-align: center;
    margin-top: .pxToVw(24)[result];
    font-size: .pxToVw(16)[result];
    letter-spacing: 1px;
    color: #333;
    white-space: pre-wrap;
    margin-bottom: .pxToVw(90)[result];
  }
  .introduce-mode-img{
    position: absolute;
    bottom: .pxToVw(12)[result];
    left: 50%;
    width: .pxToVw(66)[result];
    height: .pxToVw(68)[result];
    transform: translate(-50%, 0);
  }
  // ---------------------------引进方式 -----------------------------
  // ---------------------------待遇标准 -----------------------------
  .module-treatment-standard-top{
    margin-top: .pxToVw(101)[result];
    margin-bottom: .pxToVw(101)[result];
    z-index: 100;
  }
  .treatment-standard-tab{
    width: 100%;
    display: flex;
    z-index: 100;
    flex-wrap: wrap;
  }
  .treatment-standard-tab-item{
    // flex: 1;
    width: 25%;
    height: .pxToVw(180)[result];
    flex: auto;
    display: flex;
    align-items: center;
    // justify-content: center;
    flex-direction: column;
    background-color: #FFF4F4;
    color: #333333;
    font-size: .pxToVw(16)[result];
    cursor: pointer;
  }
  .treatment-standard-tab-item-active{
    background-color: #ffaca4;
    color: #ffffff;
    font-size: .pxToVw(18)[result];
  }
  .treatment-standard-tab-item-icon{
    width: .pxToVw(36)[result];
    height: .pxToVw(33)[result];
    margin-top: .pxToVw(40)[result];
  }
  .treatment-standard-tab-item-title{
    line-height: .pxToVw(22)[result];
    letter-spacing: 1px;
    white-space: pre-wrap;
    text-align: center;
    margin-top: .pxToVw(24)[result];
  }
  .treatment-standard-bg{
    position: absolute;
    width: 100vw;
    height: .pxToVw(199)[result];
    top: .pxToVw(138)[result];
  }
  .treatment-standard-content{
    width: 100%;
    background-color: #ffffff;
    box-shadow: 0px .pxToVw(4)[result] .pxToVw(15)[result] 0px 
      rgba(86, 86, 86, 0.15);
    z-index: 100;
  }
  .treatment-standard-desc{
    padding: .pxToVw(24)[result];
    font-size: .pxToVw(18)[result];
    line-height: .pxToVw(30)[result];
    letter-spacing: .pxToVw(2)[result];
    color: #333333;
    white-space: pre-wrap;
  }
  // ---------------------------待遇标准 -----------------------------
}
</style>
